module.exports = __webpack_public_path__ + "img/gif_track.8180aff6.gif";